import { render } from "./Order.vue?vue&type=template&id=570d303d"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import exportComponent from "B:\\桌面\\HTML\\practice\\Vue_exercise\\b2c-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__